import type { ReactNode } from 'react'
import type { UserIcon } from '@heroicons/react/24/outline'

/** Shared Vault-style heading rhythm; artwork is owned by the content shell. */
export default function AccountHero({ label, icon: Icon, title, subtitle, children }: {
  label: string
  icon: typeof UserIcon
  title: ReactNode
  subtitle: ReactNode
  children?: ReactNode
}) {
  return <section className="account-page-hero">
    <p className="account-page-hero-label"><Icon aria-hidden="true" />{label}</p>
    <h1>{title}</h1>
    <p className="account-page-hero-subtitle">{subtitle}</p>
    {children && <div className="account-page-hero-details">{children}</div>}
  </section>
}
